import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { device } from "../../device";

export const StyledArchive = styled.section``;

export const Heading = styled.h1`
  font-size: 1rem;
  color: #8b8b8b;
  text-align: left;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #e2e2e2;
  padding-bottom: 20px;
  padding-top: 20px;
`;

export const YearItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
`;

export const YearItem = styled.div`
  width: calc(100% / 2 - 20px);
  padding-top: 20px;
  margin-right: 20px;

  &:nth-child(2n) {
    margin-right: 0;
  }

  padding-bottom: 15px;
  border-bottom: 1px solid #e2e2e2;
`;

export const YearItemHeading = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 0.8125rem;
  padding-bottom: 10px;
  span {
    color: #007961;
  }
  @media ${device.tablet} {
    font-size: 1.5rem;
  }
`;

export const Highlight = styled.span`
  color: #007961;
`;

export const QuarterItems = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const QuarterItem = styled.li``;

// const activeClassName = 'is-active';
// export const QuarterLink = styled(NavLink).attrs({
//     activeClassName
// })`
//     font-size:0.8125rem;
//     line-height:1.3;
//     color: #3D434F;
//     text-decoration:none;
//     &::after {
//         content: ' →';
//         display:inline-block;
//         padding-left:5px;

//     }
// `;
export const QuarterLink = styled.a`
  font-size: 0.8125rem;
  line-height: 1.3;
  color: ${(props) => (props.isActive ? "#008067" : "#008067")};
  font-weight: ${(props) => (props.isActive ? "bold" : "normal")};
  /* text-decoration: ${(props) => (props.isActive ? "underline" : "none")}; */
  text-decoration: underline;
  &::after {
    content: "";
    display: inline-block;
    padding-left: 5px;
  }

  &:hover {
    text-decoration: underline;
  }

  @media ${device.tablet} {
    font-size: 1.25rem;
  }
`;

export const QuarterButton = styled.button`
  background: none;
  border: none;
  font-size: 0.8125rem;
  line-height: 1.3;
  color: #3d434f;
  text-decoration: none;
  &::after {
    content: " →";
    display: inline-block;
    padding-left: 5px;
  }
`;
